import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Tressa SS 3 Character w/ Alfyn" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Run from Pirate, heal before Mikk & Makk if needed.`}</p>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`T1-3: Tradewinds Mikk`}<br parentName="p"></br>{`
`}{`T4: Tradewinds x4 Mikk (kill)`}<br parentName="p"></br>{`
`}{`T5-6: Tradewinds / Grape`}<br parentName="p"></br>{`
`}{`T7: Tradewinds x4`}<br parentName="p"></br>{`
`}{`T8: Bow`}<br parentName="p"></br>{`
`}{`T9: Defend`}<br parentName="p"></br>{`
`}{`T10: Bow`}<br parentName="p"></br>{`
`}{`T11: Tradewinds x4`}</p>
    <p>{`Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, kill Cait on the way. Run from Scholar Shrine battle, not enough money for Dancers.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <p>{`Hired Help, `}<strong parentName="p">{`Scholar`}</strong>{`, Fire Storm + Lightning Blast`}</p>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <p>{`Evasive Maneuvers`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`, go to `}<strong parentName="p">{`Cobbleston`}</strong>{`. Buy `}<strong parentName="p">{`Curious Bloom`}</strong>{` and head out.`}</p>
    <p>{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, Tag Goldshore, Enter `}<strong parentName="p">{`Grandport Coast`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q, pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`, pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`. TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Pom L`}</strong>{`, purchase `}<strong parentName="p">{`Shadow L`}</strong>{` & `}<strong parentName="p">{`Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Dazzling Artwork`}</strong>{` and `}<strong parentName="p">{`$25000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`, go to next screen. Buy `}<strong parentName="p">{`Empowering Bracelet`}</strong>{` and pick `}<strong parentName="p">{`$4500`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`, run to `}<strong parentName="p">{`Quarrycrest`}</strong>{`. Tag `}<strong parentName="p">{`Clearbrook`}</strong>{`.`}<br parentName="p"></br>{`
`}{`You can pick up the `}<strong parentName="p">{`Old Coin`}</strong>{` by Sunshade for some extra money safety (costs 3.1s)`}</p>
    <h3 {...{
      "id": "ch2-start"
    }}>{`Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Thunder L`}</strong>{` and `}<strong parentName="p">{`Thunder M`}</strong>{`. Buy `}<strong parentName="p">{`Curious Bloom`}</strong>{`, `}<strong parentName="p">{`Shadow M`}</strong>{`. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After last purchase TP `}<strong parentName="p">{`Clearbrook`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch1"
    }}>{`Alfyn Ch.1`}</h3>
    <p>{`Battle outside break with Axe / Flee. Battle inside break with Attack.`}</p>
    <h4 {...{
      "id": "blotted-viper"
    }}>{`Blotted Viper`}</h4>
    <p>{`Shadow L`}</p>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`, run to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Shadow M Battle inside`}</p>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`Thunder L + Thunder M`}</p>
    <p>{`Steal `}<strong parentName="p">{`Nourishing S`}</strong>{`. Go to `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Nourishing M`}</strong>{`. TP `}<strong parentName="p">{`Quarrycrest`}</strong></p>
    <h3 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued.`}</h3>
    <p>{`If you get a battle outside the manse, kill with `}<strong parentName="p">{`Thunder L`}</strong>{` and S&Q inside Manse. If no battle outside, skip S&Q and kill battle inside Manse.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Hasty Helm`}</li>
        <li parentName="ul">{`Therion: Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Warrior`}</strong>{`, Thousand Spears`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Therion: Armor Corrosive, `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Nourishing Nuts on Alfyn`}</li>
        <li parentName="ul">{`Heal with Grapes.`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "omar"
    }}>{`Omar`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`2 L Stones & Mercs or something like that`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Break + Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant: HHVx4`}</li>
      <li parentName="ul">{`Other: M Stone`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3"
    }}>{`Tressa Ch.3`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Inferno Amulet.`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Remove Hasty Helm`}</li>
        <li parentName="ul">{`Therion: Remove Empowering Bracelet`}</li>
        <li parentName="ul">{`Alfyn: Inferno Amulet, Empowering Bracelet`}</li>
      </ul>
    </Menu>
    <p>{`Trigger cutscenes, buy shield.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`, run to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` in West Everhold Pass. Pick `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "shop"
      }}>{`Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 3 Injurious Seed`}</li>
        <li parentName="ul">{`Sell Gold Items`}</li>
        <li parentName="ul">{`Sell Omar's Axe`}</li>
        <li parentName="ul">{`Sell Hasty Helm`}</li>
      </ul>
    </Menu>
    <p>{`Finish quest. Go to Forbidden Grotto.`}</p>
    <p>{`S&Q at first save inside Forbidden Grotto. Pick `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "venomtooth-tiger"
    }}>{`Venomtooth Tiger`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Thousand Spears`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Injurious Seed + Curious Bloom / Noxroot`}</li>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
      <li parentName="ul">{`Therion: Pom L Merchant 1`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHVx4`}</li>
      <li parentName="ul">{`Merchant 2: Collect`}</li>
      <li parentName="ul">{`Alfyn: Purifying Seed + Curious Bloom Self (Sidestep)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Light L`}</li>
    </ul>
    <p>{`Finish quest, TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <p><strong parentName="p">{`Do this menu before entering Sewers.`}</strong></p>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Alfyn: Vivify, `}<strong parentName="li">{`Warrior`}</strong>{`, Incite + Thousand Spears`}</li>
      </ul>
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Cover`}</li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <ul>
        <li parentName="ul">{`First Aid Alfyn`}</li>
        <li parentName="ul">{`Vivify Tressa & Therion`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`.`}</p>
    <h4 {...{
      "id": "esmeralda-96450hp"
    }}>{`Esmeralda 96450HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Weak to Spear Axe Staff Wind Light (Initial) (4 Shield)`}<br parentName="p"></br>{`
`}{`Weak to Sword Bow Fire Lightning Wind (First Break) (6 Shield)`}<br parentName="p"></br>{`
`}{`Weak to Spear Dagger Ice Wind Dark`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Attack / Tradewinds`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Spear / Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Thousand Spears / Injurious Seed + Addlewort`}</li>
      <li parentName="ul">{`Tressa: Pom M Self `}<strong parentName="li">{`(Watch Cursor)`}</strong></li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x3`}</li>
      <li parentName="ul">{`Alfyn: Incite`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Lightning Blast`}</li>
      <li parentName="ul">{`Therion: Olive L Alfyn`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Lightning Blast / Tradewinds / Bow`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Sword / Tradewinds`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Injurious Seed + Noxroot / Sword x3`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x3`}</li>
      <li parentName="ul">{`Alfyn: L Stone`}</li>
      <li parentName="ul">{`Therion: HHV x4`}</li>
    </ul>
    <p>{`Finish quest, skip cutscenes, `}<strong parentName="p">{`GG`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      